import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Newspaper, CalendarDays, Tag } from "lucide-react";
import PageHero from "../components/PageHero";
import Seo from "../components/Seo";
import { Reveal } from "../components/Reveal";
import { api, resolveMedia } from "../lib/api";
import { useLang } from "../i18n";

export default function Blog() {
  const { pick } = useLang();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/blogs").then((r) => setItems(r.data.items || [])).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <main>
      <Seo
        title="ब्लॉग एवं समाचार — Anansha Welfare Society"
        description="Anansha Welfare Society Varanasi की गतिविधियों, अभियानों और सामाजिक पहलों की ताज़ा खबरें और लेख।"
        path="/blog"
        breadcrumb={["ब्लॉग"]}
      />
      <PageHero
        overline={{ hi: "समाचार", en: "News" }}
        title={{ hi: "ब्लॉग एवं समाचार", en: "Blog & News" }}
        description={{ hi: "संस्था की गतिविधियों, अभियानों और कहानियों की ताज़ा जानकारी।", en: "Latest updates on our activities, campaigns and stories." }}
        testid="blog-page-heading"
      />
      <section className="py-20 bg-ngo-cream min-h-[40vh]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          {loading ? (
            <p className="text-center text-ngo-ink/50 py-16">...</p>
          ) : items.length === 0 ? (
            <div data-testid="blog-public-empty" className="text-center py-20">
              <Newspaper size={40} className="mx-auto text-ngo-deep/40" />
              <p className="mt-4 text-ngo-ink/60">{pick({ hi: "जल्द ही यहां समाचार और लेख प्रकाशित होंगे।", en: "News and articles will be published here soon." })}</p>
            </div>
          ) : (
            <div data-testid="blog-public-list" className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {items.map((b, i) => (
                <Reveal key={b.id} i={i % 3}>
                  <Link to={`/blog/${b.slug}`} data-testid={`blog-card-${i}`} className="group block bg-white rounded-2xl border border-ngo-deep/10 overflow-hidden hover:-translate-y-1.5 hover:shadow-[0_18px_44px_rgba(23,107,58,0.14)] transition-[box-shadow,transform] duration-300">
                    {b.featured_image ? (
                      <img src={resolveMedia(b.featured_image)} alt={b.title} loading="lazy" className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-700" />
                    ) : (
                      <div className="w-full h-48 bg-ngo-mint flex items-center justify-center text-ngo-deep/40"><Newspaper size={36} /></div>
                    )}
                    <div className="p-6">
                      <div className="flex flex-wrap items-center gap-3 text-xs text-ngo-ink/50">
                        {b.published_at && <span className="inline-flex items-center gap-1"><CalendarDays size={12} /> {new Date(b.published_at).toLocaleDateString("hi-IN")}</span>}
                        {b.category && <span className="inline-flex items-center gap-1 text-ngo-leaf font-semibold"><Tag size={12} /> {b.category}</span>}
                      </div>
                      <h2 className="mt-3 font-heading font-bold text-lg text-ngo-ink leading-snug group-hover:text-ngo-deep transition-colors duration-200">{b.title}</h2>
                    </div>
                  </Link>
                </Reveal>
              ))}
            </div>
          )}
        </div>
      </section>
    </main>
  );
}
